// extracted by mini-css-extract-plugin
export default {"container_domicile":"style_container_domicile__NUSTW"};